// extracted by mini-css-extract-plugin
module.exports = {"loadMoreData":"LoadMoreButton_loadMoreData__2eg3U","allDataLoaded":"LoadMoreButton_allDataLoaded__1Hz3B"};